import { SVGProps } from 'react'

export function WarningGlyphOutlineIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 72 72" fill="currentColor" {...props}>
      <path d="M38.2499 27V47.25H33.7499V27H38.2499ZM35.9999 51.75C34.1999 51.75 32.6249 53.325 32.6249 55.125C32.6249 56.925 34.1999 58.5 35.9999 58.5C37.7999 58.5 39.3749 56.925 39.3749 55.125C39.3749 53.325 37.7999 51.75 35.9999 51.75ZM66.8249 65.475C65.9249 66.825 64.5749 67.5 62.9999 67.5H8.9999C7.4249 67.5 6.0749 66.825 5.1749 65.475C4.2749 64.125 4.2749 62.55 4.9499 61.2L31.9499 7.2C32.6249 5.4 34.1999 4.5 35.9999 4.5C37.7999 4.5 39.3749 5.4 40.0499 6.975L67.0499 60.975C67.7249 62.55 67.7249 64.125 66.8249 65.475ZM62.9999 63L35.9999 9L8.9999 63H62.9999Z" />
    </svg>
  )
}
